<template>
    <div>
        <!-- Lista de contatos do grupo -->
        <div class="contacts" v-if="!contacts.loading">

            <mu-row align-items="baseline">
                <mu-col span="12" sm="3" md="3" lg="3" xl="3">
                    <mu-title color="secondary" type="h3">Contatos do grupo</mu-title>
                </mu-col>
                <mu-col span="12" sm="9" md="9" lg="9" xl="9">
                    <div class="search">
                        <input type="text" v-model="search" @keyup.enter="load()" placeholder="Buscar por nome ou telefone *">
                        <mu-button :disabled="!search" @click="load()" round color="secondary">Ok</mu-button>
                        <mu-button round @click="clear()" color="#f5f5f5" textColor="#999">Limpar</mu-button>
                    </div>
                </mu-col>
            </mu-row>

            <mu-paper :z-depth="1">
                <mu-data-table :columns="contacts.columns" :data="contacts.list" class="mu-table-custom">
                    <template slot-scope="scope">
                        <td>{{ scope.row.firstname }}</td>
                        <td>{{ scope.row.phone }}</td>
                        <td class="is-center">
                            <!-- <mu-badge content="Contato bloqueado" color="#000" v-if="scope.row.blacklist"></mu-badge> -->
                            <mu-switch v-model="scope.row.blacklist" color="#000000" @change="blacklist(scope.row.id, scope.row.blacklist)"></mu-switch>
                        </td>
                        <td class="is-center">
                            <mu-badge content="Inativo" v-if="scope.row.status == 'I'"></mu-badge>
                            <mu-badge content="Ativo" color="success" v-if="scope.row.status == 'A'"></mu-badge>
                        </td>
                        <td class="is-center"><font-awesome-icon icon="times" class="icon-md cursor-pointer icon-margin-right color-red" @click="destroy(scope.row.id)"/></td>
                    </template>
                </mu-data-table>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="contacts.paging.total > contacts.paging.size">
                <mu-pagination :total="contacts.paging.total" :page-count="5" :page-size="contacts.paging.size" :current.sync="contacts.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de contatos do grupo" v-if="contacts.loading"></mu-loading>
    </div>
</template>

<script>
    import GroupsServices from '@/services/contacts/groups'
    import ContactsServices from '@/services/contacts/contacts'

    export default {
        name: 'contacts-groups',
        props: ['id'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                search: '',
                contacts: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Nome', name: 'name' },
                        { title: 'Telefone', name: 'contacts' },
                        { title: 'Contato Bloqueado', name: 'blacklist', align: 'center', width: 150 },
                        { title: 'Status', name: 'status', align: 'center', width: 150 },
                        { title: 'Remover', name: 'remove', align: 'center', width: 150 }
                    ],
                    list: []
                }
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            await this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            clear () {
                this.search = ''
                this.contacts.paging.page = 1
                this.load()
            },

            /**
             * Carrega os dados de clientes
             */
            async load () {
                try {
                    this.contacts.loading = true

                    let result = await GroupsServices.findAllContacts({
                        id: this.$route.params.id,
                        page: this.contacts.paging.page,
                        search: this.search
                    })

                    if (result && result.status) {
                        this.contacts.paging.page = result.currentPage
                        this.contacts.paging.total = result.rowCount
                        this.contacts.list = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os contatos do grupo.')
                } finally {
                    this.contacts.loading = false
                }
            },

            /**
             * Responsável por excluir o contato
             */
            async destroy (id) {
                try {
                    this.$eventHub.$emit('loading', true, 'Removendo o contato do grupo.')

                    let result = await GroupsServices.destroyContacts({
                        id: this.id,
                        contact_id: id
                    })

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.load()
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível remover o contato.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Gatilho para atualizar o campo blacklist do contato
             */
            async blacklist (id, blacklist) {
                try {
                    let result = await ContactsServices.blacklist({
                        id,
                        blacklist
                    })

                    if (result && result.status) {
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível bloquear o contato.')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .contacts

        .mu-paper
            padding 0

        .search
            text-align left
            margin-bottom 25px

            input
                width 100%
                padding 6px 0
                margin-bottom 10px
                text-indent 10px
                border 1px #ccc solid
                border-bottom-width 2px

            .mu-button
                margin-left 0
                &:last-child
                    margin-left 10px

        .cursor-pointer
            cursor pointer

        .paginate
            padding 20px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .search
            text-align right !important
            padding 0 10px 10px 10px
            margin 0 !important

            input
                width 50% !important
                padding 6px 0
                margin-bottom 0 !important
                text-indent 10px
                border 1px #ccc solid
                border-bottom-width 2px

            .mu-button
                margin-left 10px !important
</style>
